import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import Div from '../../../../shared/components/CustomDiv';
import { useDrop } from 'react-dnd';

// Who Are We

const TripleBlockText = (props) => {
    const [hover, setHover] = useState(false);

    let { 
        preview = false,  
        id = null, 
        data = null,
        inputCallback = null,
        update = null
    } = props;

    const [collectedProps, drop] = useDrop({
        accept: ['media'],
        drop: (item) => {
        data.inputs['backgroundImage'].value = item.media.node;
        update();
        }
    });

    const style = {
        boxShadow: 'none',
        backgroundColor: 'white',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        position: 'relative',
        width: '100%',
        // height: '880px',
        marginBottom: 20
    };

    return (
        <div
        className={`offer-template-scope`}  
        ref={drop} 
        onMouseEnter={() => setHover(true)} 
        onMouseLeave={() => setHover(false)}
        style={{
            ...style,
        }}
        >
            { !preview && props.children }
            <div className="container">
                <div className="breacrumb">
                    <Div data={data} className="category" preview={preview} component={id} block={'category'} inputCallback={inputCallback} nopadding={true} style={{backgroundColor: data?.inputs?.primaryColor.value, color: data?.inputs?.secondaryColor.value}} />
                    <Div data={data} className="sub-category" preview={preview} component={id} block={'sub_category'} inputCallback={inputCallback} nopadding={true} style={{color: data?.inputs?.primaryColor.value, backgroundColor: data?.inputs?.secondaryColor.value}} />
                </div>
                <Div data={data} className="subTitle" preview={preview} component={id} block={'subTitle'} inputCallback={inputCallback} nopadding={true} style={{borderLeft: `3px solid ${data.blocks.subTitle.inputs.color.value}`}} />
                <div className="container-blocs type-blocs type-text justify-content-start">
                    {
                        data.blocks.informations.config.map((text, index) => (
                            <Div data={text} className="bloc-blocs" preview={preview} component={id} block={'info'} inputCallback={() => inputCallback(id, 'info')} nopadding={true} />
                        ))
                    }
                </div>
            </div>
        </div>
    );
};

TripleBlockText.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default TripleBlockText;